<template>
  <div class="container"></div>
</template>

<script>
  export default {
    name: "Entrance",
    mounted() {
      setTimeout(() => {
        this.$router.push('/board');
      }, 2000);
    }
  }
</script>

<style scoped>

  .container {
    background: url("../assets/img/entrance_bg.png") no-repeat fixed center;
    background-size: contain;
  }

</style>